module.exports = __webpack_public_path__ + "img/ai_recycle_01.d9a0e077.png";